import { CAMPO_REQUERIDO } from '../constantes/mensajes';

/**
 * Función reutilizable para hacer un campo requerido basado en otra propiedad.
 * 
 * @param {yup.BaseSchema} campo - Campo con tipo de dato de Yup (yup.string(), yup.number(), etc.).
 * @param {string} campoCondicion - Nombre del campo que determina si el otro campo es requerido.
 * @param {string} mensajeError - Mensaje de error cuando el campo es requerido.
 * @returns {yup.BaseSchema} - Esquema de Yup con validación condicional.
 */
export const esRequeridoSi = (campo, campoCondicion, mensajeError = CAMPO_REQUERIDO) =>
  campo.when(campoCondicion, ([valorCondicion], field) =>
    valorCondicion ? field.required(mensajeError) : field.nullable()
  );
